import { createSlice } from "@reduxjs/toolkit";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
}; 

const setAddressSlice = createSlice({
  name: "setAddress",
  initialState: data,
  reducers: {
   setAddressSlice(state) {
      state.isLoading = true;
    },
   setAddressSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    setAddressSliceFailure(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    setAddressSliceReset(state) {
      state.isLoading = false;
      state.data = null;
    },
  },
});

export const setAdminBookingOrderAddress: any = (data:any) => async (dispatch: any) => {
  try {
    dispatch(setAddressAction.setAddressSlice());
    
    dispatch(setAddressAction.setAddressSliceSuccess(data));
  } catch (e: any) {
    dispatch(setAddressAction.setAddressSliceFailure(e?.response?.data));
  }
};

export default setAddressSlice.reducer;
export const setAddressAction = setAddressSlice.actions;